module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/carousel_02@1x.973f02d.png";